var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6F7F7",
    fillRule: "nonzero",
    d: "M8.92869727,24.298133 C8.61050556,24.6163051 8.10910322,24.5466737 7.87400419,24.1765864 L7.6239876,23.7859324 C7.42890015,23.4810845 7.46417217,23.0609723 7.72438781,22.8100663 L14.641958,16.0008804 L7.72211025,9.18944671 C7.46610811,8.9353357 7.42905442,8.51842804 7.62320797,8.21503952 L7.86886537,7.83132074 C8.10446548,7.44958584 8.61698121,7.38276112 8.92511747,7.7000826 L16.0000042,14.6641202 L23.0670244,7.70799199 C23.3830188,7.38276112 23.8955345,7.44958584 24.126784,7.82439879 L24.3768006,8.21505286 C24.5709456,8.51842804 24.5338919,8.9353357 24.2764004,9.19091892 L17.3580412,16.0008814 L24.2719436,22.806492 C24.5358278,23.0609723 24.5710999,23.4810845 24.3760039,23.7859457 L24.1269003,24.1751679 C23.8908968,24.5466737 23.3894944,24.6163051 23.0740944,24.3009026 L15.9999995,17.3376444 L8.92869727,24.298133 Z M16.0674711,16.0008805 L16,16.0672945 L15.9325289,16.0008805 L16,15.9344665 L16.0674711,16.0008805 Z M8.55895424,23.3917181 L8.44978521,23.4991761 C8.448926,23.4991685 8.44806672,23.4991642 8.44720738,23.499163 C8.49303703,23.4426719 8.50803098,23.3795493 8.49632722,23.320572 L8.50681493,23.3102487 L8.55895424,23.3917181 Z M8.50609291,8.69063405 L8.49591146,8.68061189 C8.50823967,8.62077118 8.49261431,8.55760967 8.44569025,8.5007687 C8.44645785,8.50077628 8.44722536,8.50078134 8.44799274,8.50078388 L8.55818102,8.60924572 L8.50609291,8.69063405 Z M23.4931765,23.3102611 L23.5035937,23.3205151 C23.4915103,23.3803913 23.5066962,23.4441736 23.5525729,23.4995596 C23.5519045,23.4995579 23.5512362,23.4995582 23.550568,23.4995604 L23.4410308,23.3917395 L23.4931765,23.3102611 Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.01c883a2.svg";
export { ForwardRef as ReactComponent };